module.exports = __webpack_public_path__ + "img/prototipo.4a6b6ab0.svg";